import { AppState } from 'app-redux/reducers';
import { ErrorHandlerState } from 'app-redux/reducers/error-handler.reducer';
import { createSelector } from 'reselect';

export const getErrorHandlerState = (state: AppState) => state.errorHandlerState || {} as ErrorHandlerState;

export const getErrorMessage = createSelector(getErrorHandlerState,
  (errorHandlerState) => errorHandlerState.errorData);
